import type { ClientInit } from "@sveltejs/kit/hooks";
import { recoverFromMissingChunks } from "#lib/stale-build.ts";

const HANDOFF_ELEMENT_ID = "colossus-handoff";

export const init: ClientInit = async () => {
  recoverFromMissingChunks();
  const element = document.getElementById(HANDOFF_ELEMENT_ID);
  if (element === null) return;
  const { takeHandoff } = await import("#lib/handoff.ts");
  takeHandoff(element);
};
